import superagent from 'superagent'
import Logger from '../utils/Logger'

import { getUserIdFromCookieInfo } from '../helpers/CitrusHelper'

const logger = new Logger()

export default function getCitrusBannersx(searchTerm = '', categoryName = '', placement = '', isSponsoredPage = false) {
  const cookies = typeof window !== 'undefined' && window.document ? document.cookie : null
  const citrusCatalogId =
    typeof window !== 'undefined' && window.citrusCatalogId ? window.citrusCatalogId : process.env.CITRUS_CATALOG_ID
  const citrusContentId =
    typeof window !== 'undefined' && window.citrusContentId ? window.citrusContentId : process.env.CITRUS_CONTENT_ID
  const userId = cookies ? getUserIdFromCookieInfo(cookies) : ''
  let slotId

  const isServer = process.env.CITRUS_BASE_URL || false

  switch (placement) {
    case 'search-below-grid-argos':
      slotId = 'SLP_search_below_grid'
      break
    case 'category-below-grid-argos':
      slotId = 'PLP_category_below_grid'
      break
    case 'category-landing-argos':
      slotId = 'CLP_category_landing'
      break
    case 'argos-category':
      slotId = 'PLP_Category_in_grid'
      break
    default:
      break
  }

  const prepareCategoryFilter = categoryData => {
    if (categoryData?.constructor === Array) return categoryData.map(category => [`taxonomy:${category}`])
    return [[`taxonomy:${categoryData}`]]
  }

  const requestBody = {
    sessionId: `${userId}`,
    placement: `${placement}`,
    searchTerm: searchTerm || '',
    catalogId: `${citrusCatalogId}`,
    productFilters: searchTerm ? null : prepareCategoryFilter(isSponsoredPage ? categoryName.split(',') : categoryName),
    options: {
      filterMode: `${placement === 'category-below-grid-argos' ? 'OrAnd' : 'AndOr'}`
    },
    contentStandardId: `${citrusContentId}`,
    bannerSlotIds: [
      {
        slotId: `${slotId}`,
        maxNumberOfAds: placement === 'category-landing-argos' ? 6 : 2
      }
    ]
  }

  const getHeaders = () => {
    if (isServer) {
      return {
        accept: 'application/json',
        'content-type': 'application/json',
        authorization: `${process.env.CITRUS_API_KEY}`,
        'cache-control': 'no-cache'
      }
    }
    return {
      'cache-control': 'no-cache'
    }
  }

  const parseResponseText = text => {
    try {
      return JSON.parse(text)
    } catch (error) {
      return {}
    }
  }

  const citrusUrl = isServer ? `${process.env.CITRUS_BASE_URL}/v1/ads/bannerx` : '/finder-api/sbanners/'

  return new Promise(resolve => {
    let request = superagent
      .post(citrusUrl, requestBody)
      .set(getHeaders())
      .timeout({
        response: 10000,
        deadline: 20000
      })

    if (!isServer) {
      request = request.withCredentials()
    }

    request.end((err, response) => {
      const logInfo = {
        categoryName,
        placement
      }
      if (err) {
        logger.error('apiLogger', logInfo, 'Citrus API request failed')
        resolve({ status: err.status, error: err.text })
      }
      if (response && response.text) {
        logger.info('apiLogger', logInfo, 'Citrus API response')
        resolve(parseResponseText(response.text))
      }
    })
  })
}
